// CAMPAGNE URBAINE — AJOUT DES CARTES AU PANIER
document.addEventListener("DOMContentLoaded", () => {

  // Boutons Ajouter
  const addButtons = document.querySelectorAll(".cu-add-btn");

  if (!addButtons.length) return;

  addButtons.forEach(btn => {
    btn.addEventListener("click", async () => {

      const parent = btn.closest(".cu-card-option");
      if (!parent) return;

      const type = btn.dataset.type;

      let productHandle = "";
      let props = {};

      if (type === "simple") {
        productHandle = "carte-pre-imprimee-pour-toi";
        props["Nom du donneur"] = parent.querySelector("[data-field='name-simple']").value;
      }

      if (type === "premium") {
        productHandle = "carte-premium-personnalisee-message-ecrit-a-la-main";
        props["Nom du donneur"] = parent.querySelector("[data-field='name-premium']").value;
        props["Message"] = parent.querySelector("[data-field='message-premium']").value;
      }

      const product = window.allProducts?.[productHandle];

      if (!product) {
        console.error("Produit introuvable:", productHandle);
        return;
      }

      const variantId = product.variants[0]?.id;

      // Envoi à Shopify
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: props
        })
      });

      // Show popup
      const popup = document.getElementById("cu-card-popup");
      if (popup) popup.style.display = "block";
    });
  });

  // Fermeture popup
  const popup = document.getElementById("cu-card-popup");
  if (popup) {
    popup.addEventListener("click", e => {
      if (e.target.classList.contains("cu-popup-backdrop") ||
          e.target.classList.contains("cu-popup-close")) {
        popup.style.display = "none";
      }
    });
  }

});
